module.exports = __webpack_public_path__ + "img/emo_18.0e31704d.png";